import React from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import { ITooltipData } from 'components/ModalTooltip/types';

interface Props {
  hasUseEventId: boolean,
  id: number,
  image: string,
  level: number,
  name: string,
  onClick: Function,
  tooltipData: ITooltipData,
  tooltipTimeout?: number,
}

export default function AvailableItemComponent({
  onClick,
  hasUseEventId,
  level,
  id,
  image,
  name,
  tooltipData,
  tooltipTimeout,
}: Props) {
  return (
    <div
      className={classnames(
        hasUseEventId && 'icon--usable',
        'icon icon--emphasize icon--available-item',
      )}
      data-quality-id={id}
    >
      <Image
        className={classnames(
          'equipped-group__available-item',
        )}
        icon={image}
        alt={name}
        type="small-icon"
        onClick={onClick}
        tooltipData={tooltipData}
        tooltipPos="bottom"
        tooltipTimeout={tooltipTimeout}
      />
      <span className="js-item-value icon__value">
        {level}
      </span>
    </div>
  );
}
